import { render, staticRenderFns } from "./PlusAppSidebar.vue?vue&type=template&id=223732a9&scoped=true"
import script from "./PlusAppSidebar.vue?vue&type=script&lang=js"
export * from "./PlusAppSidebar.vue?vue&type=script&lang=js"
import style0 from "./PlusAppSidebar.vue?vue&type=style&index=0&id=223732a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223732a9",
  null
  
)

export default component.exports